var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "titlebar" },
    [
      _vm.backPath
        ? _c(
            "div",
            { staticClass: "back-btn", on: { click: _vm.handleBackClick } },
            [_c("i", { staticClass: "zmdi zmdi-chevron-left text-4xl" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading ? _c("h1", [_c("b-skeleton")], 1) : _vm._t("default"),
      _vm._v(" "),
      _c("LanguageSelection", { staticStyle: { "margin-left": "auto" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }